import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Avatar,
  Button,
  Alert
} from '@mui/material';
import { Person, Save } from '@mui/icons-material';

const UserProfileCard = () => {
  return (
    <Card>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <Person sx={{ mr: 1 }} />
          <Typography variant="h6">
            Profile Information
          </Typography>
        </Box>

        <Alert severity="info" sx={{ mb: 2 }}>
          Profile editing features are being migrated to Material-UI
        </Alert>

        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <Avatar sx={{ width: 64, height: 64, mr: 2 }}>
            <Person />
          </Avatar>
          <Box>
            <Typography variant="h6">User Profile</Typography>
            <Typography variant="body2" color="text.secondary">
              Profile details will be editable once migration is complete
            </Typography>
          </Box>
        </Box>

        <Button 
          variant="contained" 
          startIcon={<Save />}
          disabled
          sx={{ mt: 2 }}
        >
          Save Changes
        </Button>
      </CardContent>
    </Card>
  );
};

export default UserProfileCard;